import React, { memo, useEffect, createRef } from 'react';
import {
	View, TextInput, Platform, RefreshControl, FlatList
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import EStyleSheet from 'react-native-extended-stylesheet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styles from './styles';
import { useInjectReducer } from '../../utils/injectReducer'; // eslint-disable-line
import { t } from '../../services/i18n';
import { filtering } from './actions';
import { loadLocations } from '../../providers/LocationsProvider/actions';
import reducer from './reducer';
import { makeSelectLocationsLoading, makeSelectLocations } from '../../providers/LocationsProvider/selectors';
import makeSelectSearch from './selectors';
import Title from '../../components/Content/Title';
import Content from '../../components/Content/Content';
import SubTitle from '../../components/Content/SubTitle';
import IconHeader from '../../components/IconHeader';
import IconListControl from '../../components/IconListControl';
import { makeSelectNetworkIsConnected } from '../../selectors';

const key = 'search';

function Search({
	search,
	locations,
	loading,
	handleFilter,
	handleLoadLocations,
	header,
	isConnected
}) {
	useInjectReducer({ key, reducer });
	const searchInputRef = createRef();

	useEffect(() => {
		isConnected && handleLoadLocations();
	}, [isConnected]);

	useEffect(() => {
		handleFilter(search.filter, 'filter', locations);
	}, [locations]);

	return (
		<View style={styles.contentContainer}>
			<FlatList
				keyboardDismissMode={Platform.OS === 'ios' ? 'interactive' : 'on-drag'}
				refreshControl={<RefreshControl refreshing={loading} onRefresh={handleLoadLocations} />}
				ListHeaderComponent={
					<View style={[styles.heading, header && styles.headingNoPaddingTop]}>
						{header || (
							<>
								<Title title={t('Search in your Locations')} />
								<IconHeader
									color={EStyleSheet.value('$peach')}
									icon="md-search"
								/>
							</>
						)}
						<View>
							{header && <SubTitle title={t('Search in your locations')} />}
							<View style={styles.searchContainer}>
								<TextInput
									style={styles.searchInput}
									onChangeText={(value) => handleFilter(value, 'filter', locations)}
									value={search.filter}
									placeholder={t('Search by')}
									returnKeyType="search"
									ref={searchInputRef}
								/>
								<Ionicons onPress={() => searchInputRef.current.focus()} name="md-search" style={styles.searchIcon} />
							</View>
						</View>
						<Title title={`Your locations (${locations ? locations.length : 0})`} />
					</View>
				}
				data={search.filteredLocations}
				renderItem={({ item }) => (
					<View key={item.id}>
						<IconListControl
							to={`/location/${item.id}`}
							color={EStyleSheet.value('$blue')}
							title={item.field2 || item.id}
							icon="md-pin"
						/>
					</View>
				)}
				ListFooterComponent={
					(locations.length === 0 || !locations) && !loading && (
						<SubTitle title={t('You do not have any location associated')} />
					)
				}
				initialNumToRender={10}
			/>
			</View>
	);
}

const mapStateToProps = createStructuredSelector({
	locations: makeSelectLocations(),
	loading: makeSelectLocationsLoading(),
	search: makeSelectSearch(),
	isConnected: makeSelectNetworkIsConnected(),
});

export function mapDispatchToProps(dispatch) {
	return {
		handleFilter: (value, name, locations) => dispatch(filtering(value, name, locations)),
		handleLoadLocations: () => dispatch(loadLocations()),
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDispatchToProps,
);

export default compose(
	withConnect,
	memo,
)(Search);
